<!-- ----------------------------------------------- -->
<template>
  <v-col class="card">
    <v-card class="com-pc-card if-srch-card">
      <div class="com-pc-card-header if-srch-header">
        <span class="com-pc-card-title">お知らせ検索・検索一覧</span>
      </div>
      <if-search></if-search>
    </v-card>
  </v-col>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 お知らせ検索
 * Info.vue
 * @author LIS
 */

/** お知らせ検索・検索結果一覧カード */
import IfSearch from "../../components/pc/full/IfSearch.vue";

export default {
  name: "info",
  components: {
    IfSearch
  }
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.card {
  padding: 16px;
  height: 100%;
  .if-srch-card {
    display: flex;
    flex-direction: column;
    height: 100%;
    .if-srch-header {
      display: flex;
    }
  }
}
</style>
